import { Swiper } from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.swiper-container--text-with-cards';
const swiperInstances = new Map();

function initSwipers() {
  const sliders = document.querySelectorAll(swiperContainerClass);

  sliders.forEach((slider, index) => {
    const key = slider.dataset.swiperId || index;
    const viewportWidth = window.innerWidth;

    if (viewportWidth < breakpoints.md) {
      if (swiperInstances.has(key)) {
        swiperInstances.get(key).destroy(true, true);
        swiperInstances.delete(key);
      }
      return;
    }

    if (swiperInstances.has(key)) {
      swiperInstances.get(key).destroy(true, true);
      swiperInstances.delete(key);
    }

    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesOffsetAfter: 48,
      loop: false,
      grabCursor: true,
      freeMode: true,
    });

    swiperInstances.set(key, swiper);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initSwipers();
    });
  }

  initSwipers();
});

window.addEventListener('resize', () => {
  initSwipers();
});
